<template>
  <el-dialog title="Pré-postagem" :append-to-body="false" center :visible.sync="dialog">
    <el-form>
      <el-row :gutter="5">
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('altura')" prop="name">
            <el-input maxlength="80" ref="name" v-model="ruleForm.height"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('largura')" prop="active">
            <el-input maxlength="80" ref="name" v-model="ruleForm.width"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('comprimento')" prop="active">
            <el-input maxlength="80" ref="name" v-model="ruleForm.length"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('peso-g')" prop="active" class="is-required">
            <el-input maxlength="80" ref="name" v-model="ruleForm.weight"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-alert class="alert-title"
        show-icon
        title="Ao alterar o peso ou as dimensões da postagem o preço dela pode sofrer altarações no momento da inclusão "
        type="info">
      </el-alert>              

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="default" @click.stop.prevent="dialog = false">Cancelar</el-button>
      <el-button type="primary" @click.stop.prevent="save">Salvar</el-button>
    </span>
  </el-dialog>

</template>

<script>
export default {
  name: 'PostEditWeight',
  data() {
    return {
      dialog: false,
      ruleForm: {
        weight: 0,
        length: 0,
        width: 0,
        height: 0,
      }
    }
  },
  methods: {
    setup(data) {
      this.ruleForm.height = data.height;
      this.ruleForm.weight = data.weight;
      this.ruleForm.length = data.length;
      this.ruleForm.width = data.width;
      this.dialog = true;
    },
    save() {
      this.$emit('save');
      this.dialog = false;
    }
  }
}
</script>